import { forwardRef, type ChangeEvent, type ComponentPropsWithoutRef } from 'react';

export type SelectProps = Omit<
  ComponentPropsWithoutRef<'select'>,
  'onChange' | 'value' | 'defaultValue'
> & {
  value: string;
  onChange: (value: string) => void;
};

/** Controlled native select styled like TextInput. Requires `@import '@nrx/ui/theme.css'`. */
export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { value, onChange, className, ...props },
  ref,
): React.JSX.Element {
  const handleChange = (event: ChangeEvent<HTMLSelectElement>): void => {
    onChange(event.target.value);
  };

  const classes = ['input', 'select', className].filter(Boolean).join(' ');

  return <select ref={ref} value={value} className={classes} onChange={handleChange} {...props} />;
});
